import { useCollision, RECT } from '@lib/systems/collision'
import { useMouseInput } from '@lib/systems/mouseInput'
import { usePixelRenderer, renderer } from '@lib/renderers/pixel'
import { useCamera } from '@lib/systems/camera'

import { computer } from '@game/util/computerPlayer'

const {
  cameraPosition: camera
} = useCamera()

class MousePosition {
  get x () {
    return this.position.x + camera.x
  }

  get y () {
    return this.position.y + camera.y
  }

  constructor (vector) {
    this.position = vector
  }
}

export default function () {
  const { position } = useMouseInput()

  let x, y
  const mousePos = new MousePosition(position)

  usePixelRenderer(function (ctx) {
    if (computer.resolving) return

    ; ({ x, y } = position)

    renderer.translate.x = 0
    renderer.translate.y = 0

    ctx.circ(x, y, 2, 255)
  }, {
    drawOrder: 999
  })

  useCollision({
    group: 'cursor',
    shape: RECT,
    position: mousePos,
    width: 8,
    height: 8
  })
}
